
        import 'TouchScreen.660d80f.css-module'
        export default {"TouchScreen":"TouchScreen_TouchScreen_660d80f"}
    